import {
	ClickAwayListener,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	MenuItem,
	MenuList,
	Paper,
	Popper,
} from '@mui/material';
import { FC, useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useAppDispatch, useAppSelector } from '@app/hooks/useReduxToolkit';
import { useNavigate } from 'react-router-dom';
import { closeQuicksight, PartnerState, updateActiveScope } from 'state-services';
import { useActivePartnerEntity } from '@app/hooks/useActivePartnerEntity';
import { EntityOption, getScopeKeyForEntity } from 'type-declarations';

export const OrganizationMenu: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const activePartnerEntity = useActivePartnerEntity();
	const { partners } = useAppSelector<PartnerState>((state) => state.partner);

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [submenuOpen, setSubmenuOpen] = useState(false);
	const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);

	const open = Boolean(anchorEl);

	const handleSubmenuOpen = (event): void => {
		setSubmenuAnchorEl(event.currentTarget);
		setSubmenuOpen(true);
	};

	const handleClickAway = (): void => {
		setSubmenuOpen(false);
	};

	const handleOrgChange = (entity: EntityOption): void => {
		const scopeKeyFromEntity = getScopeKeyForEntity(entity.entityType);
		dispatch(closeQuicksight());
		dispatch(updateActiveScope({ scopeKey: scopeKeyFromEntity, scopeValue: entity.id }));
		setAnchorEl(null);
		navigate('/');
	};

	const getEntityList = (): EntityOption[] => {
		const entityList: EntityOption[] = [];
		if (partners.length > 0) {
			partners.map((e) => {
				entityList.push({
					id: e.id,
					name: e.name,
					entityType: e.partnerType,
				});
			});
		}

		return entityList;
	};

	return (
		<>
			<ListItem>
				<ListItemButton
					id="basic-button"
					aria-controls={open ? 'organization-menu' : undefined}
					aria-haspopup="true"
					aria-expanded={open ? 'true' : undefined}
					onMouseEnter={handleSubmenuOpen}
					sx={{ justifyContent: 'flex-end' }}
				>
					<ListItemIcon>
						<ChevronLeftIcon />
					</ListItemIcon>

					<ListItemText>Switch Organization</ListItemText>
				</ListItemButton>
			</ListItem>
			<Popper
				open={submenuOpen}
				anchorEl={submenuAnchorEl}
				placement="left-start"
				style={{ zIndex: 1302 }} // make sure it overlays correctly
				onMouseLeave={handleClickAway}
			>
				<ClickAwayListener onClickAway={handleClickAway}>
					<Paper>
						<MenuList dense autoFocusItem={submenuOpen}>
							{getEntityList().length > 0 &&
								getEntityList().map((e) => {
									return (
										<MenuItem
											dense
											key={e.id}
											selected={e.id === activePartnerEntity.id}
											onClick={(): void => handleOrgChange(e)}
										>
											{e.name}
										</MenuItem>
									);
								})}
						</MenuList>
					</Paper>
				</ClickAwayListener>
			</Popper>
		</>
	);
};
